import { render } from "./cambiarhabitacion.vue?vue&type=template&id=5b20ca00&scoped=true"
import script from "./cambiarhabitacion.vue?vue&type=script&lang=js"
export * from "./cambiarhabitacion.vue?vue&type=script&lang=js"

import "./cambiarhabitacion.vue?vue&type=style&index=0&id=5b20ca00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b20ca00"]])

export default __exports__